import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useState } from "react";
import { routes } from "schemas/routes";

import { getPageName } from "constants/trackingProps";
import DiscoverSearchBar from "features/Influencer/Discover/Search";
import { isDemoUser } from "utils/demo";
import { isPage } from "utils/general";
import { trackEvent } from "utils/tracking";

import ReferralDialogNavigation from "../ReferralDialog/navigation";
import ChatHistory from "./ChatHistory";
import styles from "./styles";

interface TopNavigationProps {
  width: string;
  handleClick: (
    event: React.MouseEvent<HTMLButtonElement>,
    isProfileAnchor: boolean,
  ) => void;
  profileMenu: JSX.Element;
}

function TopNavigationMobile({
  width,
  handleClick,
  profileMenu,
}: TopNavigationProps) {
  const { discoverTab } = useContext(DiscoverViewContext);
  const isDiscoverPage = isPage(routes.brands);
  const { currentOrg } = useContext(OrganizationUserContext);
  const [navigationReferDialog, setNavigationReferDialog] = useState(false);

  const menuBarsMobileIcon = (
    <IconButton onClick={(e) => handleClick(e, false)} sx={styles.iconButton}>
      <Box component="i" className="fa-regular fa-bars" />
    </IconButton>
  );

  return (
    <Grid
      sx={[
        styles.mobileNavigation(discoverTab !== null),
        {
          width,
        },
      ]}
      gap={1}
      justifyContent="space-between"
      alignItems="center"
    >
      {isDiscoverPage ? (
        <>
          {menuBarsMobileIcon}
          {isDiscoverPage && <DiscoverSearchBar />}
        </>
      ) : (
        <>
          <Typography
            variant="h6"
            component="div"
            sx={{ alignItems: "center" }}
          >
            {menuBarsMobileIcon}{" "}
            {!isPage(routes.home) && <strong>{getPageName()}</strong>}
            {isPage(routes.home) && (
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  trackEvent("Refer A Friend Clicked", {
                    "Clicked From": "Navigation Bar",
                  });

                  setNavigationReferDialog(true);
                }}
                sx={{
                  fontSize: 11,
                  textDecoration: "none",
                  ml: 1,
                }}
              >
                Refer 🎁
              </Button>
            )}
          </Typography>
        </>
      )}

      {isDemoUser(currentOrg) && (
        <>
          <Grid item xs />
          <Grid item xs="auto" sx={{ mr: 1 }}>
            <ChatHistory />
          </Grid>
        </>
      )}

      <Grid
        gap={1}
        container
        item
        xs
        justifyContent={"flex-end"}
        alignItems="center"
      >
        {profileMenu}
      </Grid>

      <ReferralDialogNavigation
        open={navigationReferDialog}
        close={() => setNavigationReferDialog(false)}
        source="Top Navigation Bar"
      />
    </Grid>
  );
}

export default TopNavigationMobile;
